import { setResources } from "./bootstrapResources";
import serverReference from "shared/json/serverReference-en-US.json";
import resources from "shared/json/translations-en-US.json";

setResources(resources, serverReference);